import React, { useMemo } from 'react';

interface NotificationsBubbleProps {
    count: number,
    typeDot?: boolean,
    typeLabel?: boolean,
    className?: string
}

const NotificationsBubble = ({ count, typeDot, typeLabel, className = '' }: NotificationsBubbleProps) => {
    const content = useMemo<string | null>(() => {
        if (typeDot) {
            return null;
        }

        if (count >= 100) {
            return '99+';
        }

        return count.toString();
    }, [typeDot, count]);

    if (!count) {
        return null;
    }

    return (
        <span className={'notification-bubble ' + className + (typeDot ? ' type-dot' : '') + (typeLabel ? ' type-label' : '')}>{ content }</span>
    );

};

export default NotificationsBubble;
